import React, { useState } from 'react';
import styled from 'styled-components';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const testimonials = [
  {
    name: "Daniel Knight",
    title: "CEO Alpha Production",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    content: `Managing schedules, tracking customer information, and creating invoices was a daily headache. But with ServTrackr, everything is in one place. The platform has streamlined our workflow, and our team is more efficient than ever. I highly recommend ServTrackr to any service business looking to level up their operations.`,
  },
  {
    name: "Emma Roberts",
    title: "CTO VisionCorp",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    content: `ServTrackr has revolutionized how we handle our projects. Everything from task management to billing is seamless. I can’t imagine going back to how we did things before.`,
  },
  {
    name: "Liam Patel",
    title: "Founder Buildly",
    image: "https://randomuser.me/api/portraits/men/75.jpg",
    content: `Exceptional tool! We use ServTrackr daily for customer follow-ups and it’s made a noticeable impact on our retention.`,
  }
];

const Wrapper = styled.div`
  display: flex;
  background-color: #f4f1ff;
  padding: 5rem 0 5rem 7rem;
  justify-content: space-between;
  align-items: anchor-center;
  font-family: 'Inter', sans-serif;
  flex-wrap: wrap;
  margin-top: 9rem;

  @media screen and (max-width: 700px) {
       flex-direction: column;
       margin-top: 5rem;
       padding: 5rem 0 0rem 1rem;
      }

@media screen and (min-width: 701px) and (max-width: 1100px) {
    padding: 5rem 0 0rem 2rem;
    flex-direction: column;
    align-items: anchor-center;
        text-align: center;
}
  
`;

const Left = styled.div`
  flex: 0 0 30%;
  min-width: 30%;
  padding-right: 50px;

  @media screen and (max-width: 700px) {
  padding-right: 0px;
  }

  @media screen and (min-width: 701px) and (max-width: 1100px) {
    flex: 0 0 100%;
  min-width: 100%;
}
`;

const Title = styled.h2`
      font-size: 48px;
    font-weight: 700;
    color: #000;
    margin-bottom: 20px;
    text-align: left !important;
    line-height: 55px;

    @media screen and (max-width: 700px) {
      font-size: 30px;
      line-height: 40px;
      text-align: center !important;
  }
      @media screen and (min-width: 701px) and (max-width: 1100px) {
        text-align: center !important;
}

  span {
    display: block;
    background: linear-gradient(to right, #DD8FF9 0%, #A975FE 33%, #4F46E5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Description = styled.p`
  font-size: 15px;
  color: #555;
  font-weight: 400 !important;

  @media screen and (max-width: 700px) {
      text-align: center !important;
  }
      @media screen and (min-width: 701px) and (max-width: 1100px) {
        text-align: center !important;
}
`;

const Right = styled.div`
  flex: 0 0 63%;
  position: relative;
  max-width: 63%;
  overflow: hidden;
  padding: 0 0 60px 0;
`;




const SliderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 65%;
  padding: 4rem 0;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
    @media screen and (min-width: 701px) and (max-width: 1100px) {
      width: 100%;
}
  
`;

const SliderTrack = styled.div`
  display: flex;
  transition: transform 0.6s ease;
  transform: translateX(${props => `-${props.index * (100 / 1.5)}%`});
  width: calc(25% * ${props => props.length});
  gap: 30px;

  @media screen and (max-width: 700px) {
    width: calc(23% * ${props => props.length});
    gap: 20px;
  }
`;

const Card = styled.div`
  flex: 0 0 63.66%;
  max-width: 63.66%;
  margin: 0rem;
  background: ${props => (props.active ? '#4F46E5' : '#fff')};
  color: ${props => (props.active ? '#fff' : '#333')};
  padding: 3rem;
  border-radius: 24px;
  position: relative;
  box-shadow: ${props =>
    props.active
      ? '0 3px 10px rgb(0 0 0 / 26%)'
      : 'none'};
  z-index: ${props => (props.active ? 2 : 1)};

  @media screen and (max-width: 700px) {
    padding: 1rem;
    margin: 0 0 0 0rem;
  }

   @media screen and (min-width: 701px) and (max-width: 1100px) {
          text-align: left !important;
    font-weight: 400 !important;
    }
`;

const QuoteIcon = styled(FormatQuoteIcon)`
  position: absolute;
  bottom: 30px;
  right: 30px;
  font-size: 60px !important;
  opacity: 0.15;
`;

const Author = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
`;

const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
`;

const Info = styled.div`
  margin-left: 12px;
  h4 {
    margin: 0;
    font-weight: bold;
  }
  p {
    margin: 0;
    font-size: 0.85rem;

    @media screen and (min-width: 701px) and (max-width: 1100px) {
          text-align: left !important;
    font-weight: 400 !important;
    }
  }
    
`;

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;

  .btn-tst{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  top: 84%;
  transform: translateY(-50%);
  padding: 0 10px;
  box-sizing: border-box;
  right: 48%;
  gap: 10px;

  @media screen and (max-width: 700px) {
    right: 11%;
  }
  }
`;

const SlideIndex = styled.span`
  font-size: 14px;
  color: #555;
`;

const IconButton = styled.button`
  border: none;
    background: transparent;
    border-radius: 50%;
    padding: 8px 8px 2px 8px;
    cursor: pointer;
    box-shadow: 0 0 0 1px #363535;
    transition: all 0.3s;

  &:hover {
    background: #eaeaea;
  }
    svg{
        color: #000;
    }
`;

const TestimonialSlider = () => {
  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex(prev => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <Wrapper>
      <Left>
        <Title>
          What Our <span>Customers Are Saying</span>
        </Title>
        <Description>
          See how real businesses use ServTrackr to work smarter and serve better.
        </Description>
      </Left>

      <SliderWrapper>
        <SliderTrack index={index} length={testimonials.length}>
          {testimonials.map((t, i) => (
            <Card key={i} active={i === index}>
              <p>{t.content}</p>
              <Author>
                <Avatar src={t.image} />
                <Info>
                  <h4>{t.name}</h4>
                  <p>{t.title}</p>
                </Info>
              </Author>
              <QuoteIcon />
            </Card>
          ))}
        </SliderTrack>
        <Controls>
          <SlideIndex>
            {`${String(index + 1).padStart(2, '0')} / ${String(
              testimonials.length
            ).padStart(2, '0')}`}
          </SlideIndex>
          <div class="btn-tst">
            <IconButton onClick={prev}>
              <ArrowBackIosNew />
            </IconButton>
            <IconButton onClick={next}>
              <ArrowForwardIos />
            </IconButton>
          </div>
        </Controls>
      </SliderWrapper>
    </Wrapper>
  );
};

export default TestimonialSlider;
